import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import neptune__asset from "@/assets/restore/locations/neptune.jpg.asset.json";
import newark__asset from "@/assets/restore/locations/newark.jpg.asset.json";
import paramus__asset from "@/assets/restore/locations/paramus.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Neptune",
    address: "3600 Route 66",
    img: neptune__asset.url,
    mapUrl: map("3600 Route 66 Neptune NJ"),
    to: "/locations/new-jersey/neptune/",
  },
  {
    name: "Newark",
    address: "One Gateway Center",
    img: newark__asset.url,
    mapUrl: map("One Gateway Center Newark NJ"),
    to: "/locations/new-jersey/newark/",
  },
  {
    name: "Paramus",
    address: "140 E Ridgewood Avenue",
    img: paramus__asset.url,
    mapUrl: map("140 E Ridgewood Avenue Paramus NJ"),
    to: "/locations/new-jersey/paramus/",
  },
];

export const Route = createFileRoute("/locations/new-jersey/")({
  head: () => ({
    meta: [
      { title: "New Jersey Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in New Jersey. Book a free hair loss consultation in Neptune, Newark or Paramus and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "New Jersey Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across New Jersey and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/new-jersey/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/new-jersey/" }],
  }),
  component: () => <StateLocationsHub stateName="New Jersey" cities={cities} />,
});